import { Button } from '@mui/material'
import { useRecommendation } from '../../hooks'
import { useTranslation } from "react-i18next"

const RecommendationAction = ({ id, status, onClick, disabledAcknowledge }) => {
  const { STATUS } = useRecommendation()
  const { t } = useTranslation('common')

  if (status === STATUS.PENDING) {
    return (
      <Button
        type='button'
        variant='contained'
        size='small'
        onClick={() =>
          onClick({ id, recommendationStatus: STATUS.ACKNOWLEDGED })
        }
      >
        {t('understood')}?
      </Button>
    )
  }

  if (status === STATUS.ACKNOWLEDGED) {
    return (
      <Button
        type='button'
        variant='contained'
        size='small'
        sx={{
          backgroundColor: '#428262',
          ':hover': {
            backgroundColor: '#428262',
          },
        }}
        disabled={disabledAcknowledge}
        onClick={() => onClick({ id, recommendationStatus: STATUS.COMPLETED })}
      >
        {disabledAcknowledge ? t('singular_understood') : t('completed') + '?' }
      </Button>
    )
  }

  return <></>
}

export default RecommendationAction
